import { componentSizes } from '@/theme/componentSizes';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

const tablePaginationFooterHeight = `${componentSizes.dataGrid.footerHeight}px`;

const tablePaginationFooterContainerStyles = {
  minHeight: tablePaginationFooterHeight,
  height: tablePaginationFooterHeight,
  maxHeight: tablePaginationFooterHeight,
  width: '100%',
  paddingLeft: s('xxs'),
  paddingRight: s('none'),
  paddingTop: s('none'),
  paddingBottom: s('none'),
  boxSizing: 'border-box',
  overflow: 'hidden',
} as const;

export const tablePaginationFooterContainerSx: SxProps<Theme> =
  tablePaginationFooterContainerStyles;

export const tablePaginationRootSx: SxProps<Theme> = {
  width: '100%',
  '&.MuiTablePagination-root': {
    width: '100%',
  },
};

export const tablePaginationChromeSx: SxProps<Theme> = {
  '& .MuiTablePagination-bar': {
    minHeight: tablePaginationFooterHeight,
    height: tablePaginationFooterHeight,
    maxHeight: tablePaginationFooterHeight,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: s('md'),
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  '& .MuiTablePagination-group': {
    display: 'flex',
    alignItems: 'center',
    gap: s('md'),
  },
  '& .MuiTablePagination-pageGroup': {
    display: {
      xs: 'none',
      sm: 'flex',
    },
  },
  '& .MuiTablePagination-label': {
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .MuiTablePagination-selectInput': {
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
    transform: 'translateY(2px)',
  },
  '& .MuiTablePagination-selectValue': {
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
    transform: 'translateY(1px)',
  },
  '& .MuiTablePagination-selectIcon': {
    transform: 'translateY(0px)',
  },
  '& .MuiTablePagination-displayedRows': {
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .MuiTablePagination-navigation': {
    display: 'flex',
    alignItems: 'center',
    gap: s('md'),
  },
  '& .MuiTablePagination-pageSelect': {
    display: {
      xs: 'none',
      sm: 'flex',
    },
  },
  '& .MuiTablePagination-navigation .MuiIconButton-root': {
    margin: 0,
    minWidth: s('2xl'),
    width: s('2xl'),
    height: s('2xl'),
    padding: s('none'),
  },
};

export const dataGridFooterContainerChromeSx: SxProps<Theme> = {
  '& .MuiDataGrid-footerContainer': tablePaginationFooterContainerStyles,
};
